import axios from '../../axios'

const currentHostname = window.location.hostname;
const currentOrigin = window.location.origin;
const defaultWebsiteTitle = "Forschungsakademie | freie Texter und freie Autoren";
const defaultMetaDescription = "Online-Portal für freiberufliche Autoren und akademische";

export default {
	state: {
		uid: null,
		name: '',
		title: '',
		metaDescriptionData: '',
		logo: '',
		colors: null,
		staffUrl: process.env.VUE_APP_HOST,
		currentHostname: currentHostname,
		// currentHostname: "plattform.akadhilfe24.de",
		currentOrigin: currentOrigin
		// currentOrigin: "https://plattform.akadhilfe24.de"
	},
	getters: {
		websiteName: (state) => state.name || '',
		websiteTitle: (state) => state.title || '',
		metaDescription: (state) => state.metaDescriptionData,
		isClientUrl: (state) =>  state.staffUrl !== state.currentHostname,
		isStaffUrl: (state) => state.staffUrl === state.currentHostname,
		websiteLogo: (state) => state.logo
	},
	mutations: {
		changeName(state, name) {
			state.name = name;
		},
		changeTitle(state, title) {
			state.title = title;
		},
		changeUid(state, payload) {
			state.uid = payload;
		},
		changeLogo(state, payload) {
			// state.logo = payload;
			const host = state.currentOrigin;
			state.logo = host.replace('plattform.', '') + '/favicon.ico';
		},
		changeColors(state, payload) {
			state.colors = payload;
		},
		setDefaultWebsite(state) {
			const host = state.currentHostname;
			const minimized = host
				.replace('plattform.', '')
				.split('.')[0];

			state.name = minimized[0].toUpperCase() + minimized.substr(1);
			state.title = defaultWebsiteTitle;
			state.metaDescriptionData = defaultMetaDescription;
			state.logo = '/favicon.ico';
		}
	},
	actions: {
		async updateWebsiteInfo(context) {
			const url = `/client/auth/get-website-info?domain=${context.state.currentHostname}`;
			let result = (await axios.get(url)).data.data;

			const colors = {
				theme_color_main: result.theme_color_main,
				theme_color_secondary: result.theme_color_secondary
			};

			context.commit("changeUid", result.uid);
			context.commit("changeTitle", `Plattform - ${result.name}`);
			context.commit("changeName", result.name);
			context.commit("changeLogo", result.logo);
			context.commit("changeColors", colors);
		},
	}
};
